import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'
import { useContextInteractionMotivator } from '../../contexts/interactionMotivatorContext'
import { useEnv } from '../../utils/useEnv'
import { cn } from '../../utils/cn'

// keep in sync with the hide animation durations in the class names below
const HIDE_ANIMATION_DURATION_IN_SEC = 1

const InteractionMotivator = () => {
  const { isKiosk } = useEnv()
  const { t } = useTranslation()
  const [animateSVG, setAnimateSVG] = useState<boolean>(false)
  const { isInteractionMotivatorShown, setIsInteractionMotivatorShownWithHideAnimation } =
    useContextInteractionMotivator()

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimateSVG(true)
    }, 1700)

    return () => clearTimeout(timeout)
  }, [])

  useEffect(() => {
    if (isInteractionMotivatorShown) return

    setTimeout(() => {
      setIsInteractionMotivatorShownWithHideAnimation(false)
    }, HIDE_ANIMATION_DURATION_IN_SEC * 1000)
  }, [isInteractionMotivatorShown])

  return isKiosk ? (
    <>
      <div
        className={cn(
          'absolute left-0 top-[5vh] z-10 mt-[-20px] flex h-[60px] w-[240px] animate-[fade-in-x50-from-left_1s_forwards] items-center rounded-[0_60px_60px_0] bg-black pb-[10px] pl-[80px] pr-[10px] pt-[10px] text-[14px] text-white [transform:translateX(-100%)] tall-xxs:top-[5.5vh] tall-xs:top-[12vh] tall-xs:h-[70px] xs:tall-sm:top-[19vh] sm:top-[11.5vh] sm:h-[90px] sm:w-[300px] sm:pb-[10px] sm:pl-[100px] sm:pr-[10px] sm:pt-[10px] sm:text-[18px] md:h-[100px] md:w-[310px] md:pb-[10px] md:pl-[110px] md:pr-[10px] md:pt-[10px] lg:top-[10.5vh] lg:h-[120px] lg:w-[390px] lg:pb-[10px] lg:pl-[130px] lg:pr-[10px] lg:pt-[10px] lg:text-[24px] xl:top-[11vh] xxl:top-[15.7vh] xxl:h-[136px] xxl:w-[510px] xxl:rounded-[0_80px_80px_0] xxl:pb-[10px] xxl:pl-[240px] xxl:pr-[10px] xxl:pt-[10px] xxl:text-[26px] [&.hide]:animate-[fade-out-x50-to-left_1s_forwards]',
          { hide: !isInteractionMotivatorShown },
        )}
      >
        <div className="pr-[30px]">{t('featureDiscovery.furtherFunctionsInMenu')}</div>
      </div>
      <div
        className={cn(
          'absolute left-1/2 top-1/2 z-[100] ml-[-75px] mt-[-75px] h-[150px] w-[150px] animate-[fade-in-x50_0.6s_forwards] rounded-[50%] bg-black opacity-0 [transition:all_0.9s] sm:ml-[-120px] sm:mt-[-120px] sm:h-[240px] sm:w-[240px] lg:ml-[-177.5px] lg:mt-[-177.5px] lg:h-[355px] lg:w-[355px] [&.hide]:animate-[simple-fade-out_1s_forwards]',
          { hide: !isInteractionMotivatorShown },
        )}
      >
        <SVG
          className={cn(
            'absolute left-1/2 top-1/2 ml-[8px] h-[70px] w-[80px] animate-[fade-in-y30-center_0.4s_0.4s_ease-in-out_forwards] opacity-0 [transform:translate(-50%,calc(-50%-30px))] sm:ml-[11px] sm:h-[100px] sm:w-[100px] lg:ml-[14px] lg:h-auto lg:w-auto [&.animate]:animate-[move-horizontally_1s_0.2s_linear_infinite] [&.animate]:opacity-100 [&.animate]:[transform:translate(-50%,-50%)] [&.animate]:[&.slow-animation]:[animation-duration:100s]',
            { animate: animateSVG, 'slow-animation': !isInteractionMotivatorShown },
          )}
          src="/icons/hand@3x.svg"
        />
        <SVG
          className={cn(
            'absolute left-1/2 top-1/2 mt-[-30px] w-[100px] animate-[fade-in-y30-center_0.4s_0.2s_ease-in-out_forwards] opacity-0 [transform:translate(-50%,calc(-50%-30px))] sm:mt-[-40px] sm:w-[inherit] lg:mt-[-55px]',
            { animate: animateSVG },
          )}
          src="/icons/arrow@3x.svg"
        />
      </div>
    </>
  ) : null
}

export default InteractionMotivator
